import React from "react";
import consumerElectronics from "../../../assets/homepage/demand categories/TopCategories/Consumer Electronics.png";
import fashionApparels from "../../../assets/homepage/demand categories/TopCategories/Fashion & Apparels.png";
import toys from "../../../assets/homepage/demand categories/TopCategories/toys.png";
import sportsEntertainment from "../../../assets/homepage/demand categories/TopCategories/Sports & Entertainment.png";
import industrialMachinery from "../../../assets/homepage/demand categories/TopCategories/Industrial Machinery.png";
import homeGarden from "../../../assets/homepage/demand categories/TopCategories/Home & Garden.png";
import beautyPersonalCare from "../../../assets/homepage/demand categories/beauty1.png";

const DemandedProducts = () => {
  const images = [
    { img: consumerElectronics, text: "Consumer Electronics" },
    { img: fashionApparels, text: "Fashion & Apparels" },
    { img: toys, text: "Toys" },
    { img: sportsEntertainment, text: "Sports & Entertainment" },
    { img: industrialMachinery, text: "Industrial Machinery" },
    { img: homeGarden, text: "Home & Garden" },
    {
      img: beautyPersonalCare,
      text: "Beauty & Personal Care",
      hiddenOnMd: true,
    },
  ];

  return (
    <>
      <div className="hidden md:flex flex-col lg:max-w-[1240px] max-w-auto mx-auto md:px-[24px] lg:px-0">
        <div className="text-[18px] font-semibold leading-[30px] w-[210px] text-[#000000] select-none">
          In Demand Categories
          <hr className="bg-[#FF8100] w-[271px] h-[4px] rounded-full mt-[5px]" />
        </div>
        <div className="lg:w-[1240px] max-w-auto mx-auto md:w-[720px] h-[278px] lg:h-[278px] md:h-[142px] lg:py-[41px] lg:px-[54px] px-[50px] py-[41px] md:p-[16px] mt-[23px] bg-white rounded-xl shadow-[0_0px_0px_2px_rgba(0,0,0,0.07)]">
          <div className="flex gap-x-[50px] md:gap-x-[34px] justify-center md:justify-between items-center lg:gap-x-[50px] lg:h-[196px]">
            {images.map((item, index) => (
              // <button key={index} type="button">
              <button
                key={index}
                type="button"
                className={item.hiddenOnMd ? "hidden lg:flex" : ""}
              >
                <div className="flex flex-col items-center w-[120px] h-[196px] md:w-[70px] md:h-[110px] md:gap-y-[4px] lg:w-[120px] lg:h-[196px]">
                  <div className="bg-[#F8F8F8] rounded-full w-[120px] h-[120px] md:w-[64px] md:h-[64px] lg:w-[121px] lg:h-[121px] lg:bg-[#F8F8F8] md:bg-[#D9D9D9] flex items-center justify-center ">
                    <img
                      className="w-[84px] h-[84px] md:w-[40px] md:h-[40px] lg:w-[77px] lg:h-[77px] lg:object-contain md:object-contain object-contain"
                      src={item.img}
                      alt={item.text}
                    />
                  </div>
                  <p className="font-semibold text-[16px] text-center mt-6 w-[118px] h-[48px] md:font-medium md:text-[14px] md:mt-0 md:w-auto md:h-[42px] lg:mt-[28px] lg:font-semibold lg:text-[16px]">
                    {item.text}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default DemandedProducts;
